"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M39.5 19.0003C39.5 21.5106 37.4799 23.9141 33.9162 25.7197C30.3805 27.5111 25.4611 28.6337 20 28.6337C14.5389 28.6337 9.6195 27.5111 6.08385 25.7197C2.52014 23.9141 0.5 21.5106 0.5 19.0003C0.5 16.49 2.52014 14.0866 6.08385 12.281C9.6195 10.4896 14.5389 9.36694 20 9.36694C25.4611 9.36694 30.3805 10.4896 33.9162 12.281C37.4799 14.0866 39.5 16.49 39.5 19.0003Z",
      stroke: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      opacity: "0.2",
      d: "M39.5 10.1334C39.5 12.6437 37.4799 15.0471 33.9162 16.8527C30.3805 18.6441 25.4611 19.7667 20 19.7667C14.5389 19.7667 9.6195 18.6441 6.08385 16.8527C2.52014 15.0471 0.5 12.6437 0.5 10.1334C0.5 7.62305 2.52014 5.21963 6.08385 3.41401C9.6195 1.62261 14.5389 0.5 20 0.5C25.4611 0.5 30.3805 1.62261 33.9162 3.41401C37.4799 5.21963 39.5 7.62305 39.5 10.1334Z",
      stroke: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      opacity: "0.2",
      d: "M39.5 27.8665C39.5 30.3768 37.4799 32.7803 33.9162 34.5859C30.3805 36.3773 25.4611 37.4999 20 37.4999C14.5389 37.4999 9.6195 36.3773 6.08385 34.5859C2.52014 32.7803 0.5 30.3768 0.5 27.8665C0.5 25.3562 2.52014 22.9528 6.08385 21.1472C9.6195 19.3558 14.5389 18.2332 20 18.2332C25.4611 18.2332 30.3805 19.3558 33.9162 21.1472C37.4799 22.9528 39.5 25.3562 39.5 27.8665Z",
      stroke: "currentColor"
    })]
  });
};

exports.default = Icon;